/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { getColor, getShape } from '@airasia-phoenix/react-native/utils/utils';

const MOBILE_BOTTOM_NAVIGATION_HEIGHT = 74;

export const styles = StyleSheet.create((pd) => ({
  wrapper: {
    // `fixed` is a react-native-web extension; RN's own union stops at 'absolute'.
    position: 'fixed' as any,
    top: {
      xs: 'auto',
      md: 'auto',
    } as any,
    bottom: {
      xs: `calc(${
        MOBILE_BOTTOM_NAVIGATION_HEIGHT + pd.ref.space.spacing20.px
      }px + env(safe-area-inset-bottom, 0px))`,
      md: pd.ref.space.spacing50.px,
    } as any,
    left: {
      xs: 0,
      md: pd.ref.space.spacing50.px,
    } as any,
    right: {
      xs: 0,
      md: 'auto',
    } as any,
    paddingHorizontal: {
      xs: pd.ref.space.spacing40.px,
      md: 0,
    },
    zIndex: 2147483647,
    alignItems: {
      xs: 'center',
      md: 'flex-start',
    },
  },
  container: {
    width: '100%',
    maxWidth: {
      xs: 328,
      md: 394,
    },
    backgroundColor: getColor(pd.sys.colour.container_none),
    ...getShape(pd.sys.shape.corner.large),
    padding: pd.ref.space.spacing30.px,
    gap: pd.ref.space.spacing30.px,
    overflow: 'hidden',
    shadowColor: '#0C1D2E',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
  },
  topContent: {
    width: '100%',
    flexDirection: {
      xs: 'row',
      md: 'row',
    },
    alignItems: {
      xs: 'flex-start',
      md: 'flex-start',
    },
    gap: pd.ref.space.spacing20.px,
  },
  illustration: {
    width: 48,
    height: 48,
    ...getShape(pd.sys.shape.corner.medium),
    backgroundColor: getColor(pd.sys.colour.container_low),
  },
  copy: {
    flex: 1,
    gap: 2,
  },
  title: {
    maxWidth: '100%',
    fontSize: {
      xs: pd.sys.typescale.sub_body_text_medium.size,
      md: pd.sys.typescale.body_text_medium.size,
    },
    lineHeight: {
      xs: pd.sys.typescale.sub_body_text_medium.line_height,
      md: pd.sys.typescale.body_text_medium.line_height,
    },
    textAlign: {
      xs: 'left',
      md: 'left',
    },
  },
  body: {
    flexWrap: 'wrap',
    maxWidth: '100%',
    fontSize: {
      xs: pd.sys.typescale.caption_text.size,
      md: pd.sys.typescale.sub_body_text.size,
    },
    lineHeight: {
      xs: pd.sys.typescale.caption_text.line_height,
      md: pd.sys.typescale.sub_body_text.line_height,
    },
    textAlign: {
      xs: 'left',
      md: 'left',
    },
  },
  actions: {
    flexDirection: 'row',
    justifyContent: {
      xs: 'center',
      md: 'flex-end',
    },
    alignItems: 'center',
    gap: pd.ref.space.spacing20.px,
    marginTop: {
      xs: 0,
      md: 0,
    },
    width: '100%',
  },
  actionButton: {
    flexGrow: {
      xs: 1,
      md: 0,
    },
    flexShrink: 1,
    flexBasis: {
      xs: 0,
      md: 120,
    },
    width: {
      md: 120,
    },
  },
}));

export default styles;
